import type { WidgetProps } from "@rjsf/utils";
import KioTextWidget from "@/framework/KioForm/widgets/KioTextWidget";

const ColorWidget = (props: WidgetProps) => <KioTextWidget type="color" {...props} />;

export default ColorWidget;
